import { render } from "./HypertensionResults.vue?vue&type=template&id=3837d8b8"
import script from "./HypertensionResults.vue?vue&type=script&lang=js"
export * from "./HypertensionResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__